<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
      <butn
        v-if="!!isDetailPage"
        class="btn"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="goBack"
      ></butn>
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="140px"
      class="form"
      size="small"
      :disabled="!!isDetailPage"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="预约名称：" prop="ticketName">
            <el-input
              placeholder="请输入预约名称"
              v-model="ruleForm.ticketName"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 讲师 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="讲师：" prop="lecturerId" required>
            <load-select
              class="form-select"
              v-model="ruleForm.lecturerId"
              dictLabel="lecturerNameDesc"
              dictValue="uuid"
              :data="lecturerData"
              :page="lecturerPage"
              :hasMore="lecturerMore"
              :request="getLecturerData"
              placeholder="请选择讲师（输入名称以搜索）"
              :defaultVal="ruleForm.lecturerName"
              :isInit="isLecturerInit"
              @change="lecturerChange"
              @ChangeValue="changeLecturer"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="首页展示时间：" prop="showDate">
            <el-date-picker
              unlink-panels
              v-model="ruleForm.showDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="showDateChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="首页入口配图："
            prop="coverUrl"
            :rules="[rulesFactory.required('请上传首页入口配图')]"
          >
            <div
              v-if="ruleForm.coverUrl"
              class="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showAppViewer = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(0)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadAppCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.coverUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p class="img_tip">建议尺寸：686px*296px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="10">
          <el-form-item
            label="详情页配图："
            prop="topUrl"
            :rules="[rulesFactory.required('请上传头图')]"
          >
            <div
              v-if="ruleForm.topUrl"
              class="video-output"
              @mouseenter="showCover1 = true"
              @mouseleave="showCover1 = false"
            >
              <img :src="ruleForm.topUrl" class="avatar" />
              <div v-show="showCover1" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer1 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(1)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover1"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload1"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.topUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p>头图</p>
              <p class="img_tip">建议尺寸：1125px*632px</p>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label-width="20px"
            class="scale"
            prop="bodyUrl"
            :rules="[rulesFactory.required('请上传介绍图')]"
          >
            <div
              v-if="ruleForm.bodyUrl"
              class="video-output"
              @mouseenter="showCover2 = true"
              @mouseleave="showCover2 = false"
            >
              <img :src="ruleForm.bodyUrl" class="avatar" />
              <div v-show="showCover2" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer2 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(2)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover2"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload2"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!ruleForm.bodyUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip">
              <p>介绍图</p>
              <p class="img_tip">建议尺寸：宽度750px，高度自定义</p>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="img_download_style">
            介绍图示例.jpg&nbsp;&nbsp;
            <span
              class="download_text"
              @click="downLoadImg"
              >下载</span
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="15">
          <el-form-item label="关联限制预约活动：" prop="limitTicketId">
            <load-select
              v-if="!editFlag"
              class="form-select"
              v-model="ruleForm.limitTicketId"
              dictLabel="name"
              dictValue="uuid"
              :data="limitTicketData"
              :page="limitTicketPage"
              :hasMore="limitTicketMore"
              :request="getTicketLimitData"
              placeholder="请选择（输入名称以搜索）"
              :defaultVal="ruleForm.limitTicketName"
              :isInit="isLimitTicketInit"
              @change="limitTicketChange"
              @ChangeValue="changeLimitTicket"
            />
            <el-input
              v-else
              placeholder="请选择关联限制预约活动"
              v-model="ruleForm.limitTicketName"
              disabled
            ></el-input>
            <el-col>
              <div class="tip_style">
                选择关联限制预约活动后，对应预约活动预约成功后未参与学习，不允许参与本次预约
              </div>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="学习形式：" prop="detailTypes">
            <el-checkbox-group
              v-model="ruleForm.detailTypes"
              :disabled="editFlag"
            >
              <el-checkbox
                v-for="item in ticketTypeList"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="sub_rect" v-if="ruleForm.detailTypes.indexOf(1) !== -1">
        <div class="sub_title">线上学习配置</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="预约时间：" prop="onDetailDtos.ticketDate">
              <el-date-picker
                unlink-panels
                v-model="ruleForm.onDetailDtos.ticketDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="onTicketDateChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联直播：" prop="onDetailDtos.bizId">
              <load-select
                v-if="!editFlag"
                class="form-select"
                v-model="ruleForm.onDetailDtos.bizId"
                dictLabel="name"
                dictValue="uuid"
                :data="liveRoomData"
                :page="liveRoomPage"
                :hasMore="liveRoomMore"
                :request="getLiveRoomData"
                placeholder="请选择关联直播（输入名称以搜索）"
                :defaultVal="ruleForm.onDetailDtos.bizName"
                :isInit="isLiveRoomInit"
                @change="liveRoomChange"
                @ChangeValue="changeLiveRoom"
              />
              <el-input
                v-else
                placeholder="请选择关联直播"
                v-model="ruleForm.onDetailDtos.bizName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="线上学习时间：" prop="onDetailDtos.liveDate">
              <el-date-picker
                unlink-panels
                v-model="ruleForm.onDetailDtos.liveDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="onLiveDateChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="可预约名额：" prop="onDetailDtos.count">
              <el-input-number
                v-model="ruleForm.onDetailDtos.count"
                :step="10"
                :min="1"
                :disabled="editFlag"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规则说明：" prop="onDetailDtos.desc">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入规则说明"
                v-model="ruleForm.onDetailDtos.desc"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="sub_rect" v-if="ruleForm.detailTypes.indexOf(2) !== -1">
        <div class="sub_title">线下学习配置</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="预约时间：" prop="offDetailDtos.ticketDate">
              <el-date-picker
                unlink-panels
                v-model="ruleForm.offDetailDtos.ticketDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="offTicketDateChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联班级：" prop="offDetailDtos.bizId">
              <load-select
                v-if="!editFlag"
                class="form-select"
                v-model="ruleForm.offDetailDtos.bizId"
                dictLabel="className"
                dictValue="uuid"
                :data="classList"
                :page="pageClass"
                :hasMore="moreClass"
                :request="getClassList"
                @ChangeValue="changeClass"
                :isInit="isClassInit"
                :defaultVal="ruleForm.offDetailDtos.bizName"
                placeholder="请选择关联班级（输入班级名称关键字以查询）"
                @change="classChange"
              />
              <el-input
                v-else
                placeholder="请选择关联班级"
                v-model="ruleForm.offDetailDtos.bizName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="关联课程：" prop="offDetailDtos.subBizId">
              <load-select
                v-if="!editFlag"
                class="form-select"
                v-model="ruleForm.offDetailDtos.subBizId"
                dictLabel="courseName"
                dictValue="uuid"
                :data="courseData"
                :page="coursePage"
                :hasMore="courseMore"
                :request="getCourseData"
                placeholder="请选择关联课程"
                :defaultVal="ruleForm.offDetailDtos.subBizName"
                :isInit="isCourseInit"
                @change="courseChange"
                @ChangeValue="changeCourse"
              />
              <el-input
                v-else
                placeholder="请选择关联课程"
                v-model="ruleForm.offDetailDtos.subBizName"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="线下学习时间：" prop="offDetailDtos.liveDate">
              <el-date-picker
                unlink-panels
                v-model="ruleForm.offDetailDtos.liveDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="offLiveDateChange"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学习地址：" prop="offDetailDtos.studyAddress">
              <el-input
                placeholder="请输入学习地址"
                v-model="ruleForm.offDetailDtos.studyAddress"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="可预约名额：" prop="offDetailDtos.count">
              <el-input-number
                v-model="ruleForm.offDetailDtos.count"
                :step="10"
                :min="1"
                :disabled="editFlag"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规则说明：" prop="offDetailDtos.desc">
              <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入规则说明"
                v-model="ruleForm.offDetailDtos.desc"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col>
          <el-form-item style="text-align: center">
            <el-button @click="reset">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 图片预览 -->
    <!-- <el-image-viewer
      v-if="showAppViewer"
      :on-close="closeAppViewer"
      :url-list="[ruleForm.coverUrl]"
    /> -->
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer1"
      :on-close="
        () => {
          showViewer1 = false;
        }
      "
      :url-list="[ruleForm.topUrl]"
    />
    <el-image-viewer
      v-if="showViewer2"
      :on-close="
        () => {
          showViewer2 = false;
        }
      "
      :url-list="[ruleForm.bodyUrl]"
    />
  </div>
</template>

<script>
import moment from "moment";
import { getLecturerParamList } from "@/api/lecturer";
import { getCourseList } from "@/api/class";
import { getStudyClassList } from "@/api/classOffline";
import {
  getTicketInfo,
  addCourseTicket,
  updateCourseTicket,
  getLiveRoomSelectPage,
  selectPageLimit,
} from "@/api/liveRoom";
import { getSysParamByTypes } from "@/api/sysParam";
import LoadSelect from "@/components/load-select/index.vue";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { setItem } from "../../../utils/storage";
import { downloadByUrl } from "@/utils/common.js";
import butn from "@/components/button/index";

export default {
  components: {
    ElImageViewer,
    LoadSelect,
    butn,
  },
  data() {
    return {
      rulesFactory,
      page: 1,
      more: true,
      data: [],
      addTitle: "新增预约活动",
      ruleForm: {
        ticketName: "",
        showStartDate: "",
        showEndDate: "",
        // coverUrl: "",
        lecturerId: "",
        lecturerName: "",
        topUrl: "",
        bodyUrl: "",
        limitTicketId: "",
        limitTicketName: "",
        detailTypes: [],
        onDetailDtos: {
          ticketDate: null,
          ticketStartDate: "",
          ticketEndDate: "",
          bizId: "", // 关联业务ID（1直播间id 2班级id）
          bizName: "",
          liveDate: null,
          liveStartDate: "",
          liveEndDate: "",
          count: 100,
          bizType: 1, // 业务类型（1线上 2线下）
        },
        offDetailDtos: {
          ticketDate: null,
          ticketStartDate: "",
          ticketEndDate: "",
          bizId: "", // 关联业务ID（1直播间id 2班级id）
          bizName: "",
          subBizId: "", //关联班级课程ID
          subBizName: "",
          liveDate: null,
          liveStartDate: "",
          liveEndDate: "",
          studyAddress: "",
          count: 100,
          bizType: 2,
        },
      },
      resetForm: {},
      showCover: false,
      showAppViewer: false,
      showCover1: false,
      showCover2: false,
      showViewer1: false,
      showViewer2: false,
      editFlag: false,
      // 讲师
      lecturerPage: 1,
      lecturerMore: true,
      lecturerData: [],
      isLecturerInit: true,
      // 关联限制预约
      limitTicketData: [],
      limitTicketMore: true,
      isLimitTicketInit: true,
      limitTicketPage: 1,
      // 关联课程
      courseData: [],
      courseMore: true,
      isCourseInit: true,
      coursePage: 1,
      // 关联班级
      isClassInit: true,
      pageClass: 1,
      moreClass: true,
      classList: [],
      // 关联直播
      liveRoomData: [],
      liveRoomMore: true,
      isLiveRoomInit: true,
      liveRoomPage: 1,
      ticketTypeList: [],
      isDetailPage: 0,
      rules: {
        ticketName: [
          { required: true, message: "请输入预约名称", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        lecturerId: [
          {
            required: true,
            message: "请选择讲师",
            trigger: ["change", "blur"],
          },
        ],
        detailTypes: [
          {
            required: true,
            message: "请选择学习形式",
            trigger: ["blur", "change"],
          },
        ],
        "onDetailDtos.ticketDate": [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择预约时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        "offDetailDtos.ticketDate": [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择预约时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        "onDetailDtos.liveDate": [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择线上学习时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        "offDetailDtos.liveDate": [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请选择线下学习时间"));
              } else if (moment(value[0]) >= moment(value[1])) {
                callback(new Error("结束时间需大于开始时间"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        "onDetailDtos.count": [
          { required: true, message: "请输入可预约名额", trigger: "blur" },
        ],
        "offDetailDtos.count": [
          { required: true, message: "请输入可预约名额", trigger: "blur" },
        ],
        "offDetailDtos.studyAddress": [
          { required: true, message: "请输入学习地址", trigger: "blur" },
          rulesFactory.size("最多输入100个字", 0, 100),
        ],
        "offDetailDtos.bizId": [
          { required: true, message: "请选择关联班级", trigger: "blur" },
        ],
        "onDetailDtos.bizId": [
          { required: true, message: "请选择关联直播", trigger: "blur" },
        ],
        "onDetailDtos.bizId": [
          { required: true, message: "请选择关联直播", trigger: "blur" },
        ],
        "onDetailDtos.desc": [
          { required: true, message: "请输入规则说明", trigger: "blur" },
          rulesFactory.size("最多输入1000个字", 0, 1000),
        ],
        "offDetailDtos.desc": [
          { required: true, message: "请输入规则说明", trigger: "blur" },
          rulesFactory.size("最多输入1000个字", 0, 1000),
        ],
        "offDetailDtos.subBizId": [
          { required: true, message: "请选择关联课程", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getSysParamByTypes(["IS_VALID", "COURSE_TICKET_TYPE"]);
    this.isDetailPage = this.$route.query.isDetailPage;
    if (this.$route.query.id) {
      if (this.isDetailPage) {
        this.addTitle = "预约活动详情";
      } else this.addTitle = "编辑预约活动";
      this.editFlag = true;
      const id = this.$route.query.id;
      // 处理编辑或者详情
      this.getTicketDetail(id);
    } else {
      this.addTitle = "新增预约活动";
      this.editFlag = false;
    }
  },
  methods: {
    // 下载示例图
    downLoadImg() {
      let name = "介绍图示例.jpg";
      let url =
        "https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/live/body.png";
        downloadByUrl(name, url);
    },
    goBack() {
      this.$router.push("/courseTicketManage");
    },
    // 直播间管理-管理
    goTicketManage(item) {
      this.$router.push({
        path: "/courseTicketManage/reserveManage",
        query: {
          uuid: item.uuid,
          tab: 4,
        },
      });
    },
    /**
     * 首页展示时间变更
     */
    showDateChange(val) {
      this.ruleForm.showDate = val;
      if (val && val.length > 1) {
        this.ruleForm.showStartDate = val[0];
        this.ruleForm.showEndDate = val[1];
      }
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.ticketTypeList = res.data["COURSE_TICKET_TYPE"] || [];
      });
    },
    // 详情
    getTicketDetail(id) {
      getTicketInfo({ ticketId: id }).then((res) => {
        if (!res || res.code != 0) return;
        const { data = {} } = res;
        const form = {
          ...data,
        };
        // 处理数据结构：detailDtos
        const detailDtos = data.detailDtos;
        for (let i = 0; i < detailDtos.length; i++) {
          if (detailDtos[i].bizType == 1) {
            form.onDetailDtos = detailDtos[i];
            form.onDetailDtos.ticketDate = [
              detailDtos[i].ticketStartDate,
              detailDtos[i].ticketEndDate,
            ];
            // 线上学习时间
            form.onDetailDtos.liveDate = [
              detailDtos[i].liveStartDate,
              detailDtos[i].liveEndDate,
            ];
          } else {
            form.offDetailDtos = detailDtos[i];
            form.offDetailDtos.ticketDate = [
              detailDtos[i].ticketStartDate,
              detailDtos[i].ticketEndDate,
            ];
            // 线下学习时间
            form.offDetailDtos.liveDate = [
              detailDtos[i].liveStartDate,
              detailDtos[i].liveEndDate,
            ];
          }
        }
        this.ruleForm = form;
        this.resetForm = JSON.parse(JSON.stringify(form));
      });
    },

    // async uploadAppCover(e) {
    //   let file = e.file;
    //   // 校验文件格式是否符合要求(png格式或者jpg格式)
    //   const image = await FileHandler.isImage(file);
    //   if (!image) {
    //     this.$message({
    //       message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
    //       type: "warning",
    //     });
    //     // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
    //     this.$refs["coverUpload"].clearFiles();
    //     return;
    //   }
    //   FileHandler.uploadFile(`courseTicket/img`, file).then((res) => {
    //     const { url } = res;
    //     this.ruleForm.coverUrl = url;
    //   });
    // },
    // 上传WEB封面
    async uploadCover1(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload1"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`courseTicket/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.topUrl = url;
      });
    },
    // 上传封面
    async uploadCover2(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning",
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload2"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`courseTicket/img`, file).then((res) => {
        const { url } = res;
        this.ruleForm.bodyUrl = url;
      });
    },
    closeAppViewer() {
      this.showAppViewer = false;
    },
    // 删除配图
    deleteCover(index) {
      switch (index) {
        case 1: {
          this.ruleForm.topUrl = "";
          break;
        }
        case 2: {
          this.ruleForm.bodyUrl = "";
          break;
        }
        default: {
          this.ruleForm.coverUrl = "";
        }
      }
    },
    // 线上预约时间修改
    onTicketDateChange(val) {
      this.ruleForm.onDetailDtos.ticketDate = val;
      if (val && val.length > 1) {
        this.ruleForm.onDetailDtos.ticketStartDate = val[0];
        this.ruleForm.onDetailDtos.ticketEndDate = val[1];
      }
    },
    // 线下预约时间修改
    offTicketDateChange(val) {
      this.ruleForm.offDetailDtos.ticketDate = val;
      if (val && val.length > 1) {
        this.ruleForm.offDetailDtos.ticketStartDate = val[0];
        this.ruleForm.offDetailDtos.ticketEndDate = val[1];
      }
    },
    // 线下学习时间修改
    offLiveDateChange(val) {
      this.ruleForm.offDetailDtos.liveDate = val;
      if (val && val.length > 1) {
        this.ruleForm.offDetailDtos.liveStartDate = val[0];
        this.ruleForm.offDetailDtos.liveEndDate = val[1];
      }
    },
    // 线上学习时间修改
    onLiveDateChange(val) {
      this.ruleForm.onDetailDtos.liveDate = val;
      if (val && val.length > 1) {
        this.ruleForm.onDetailDtos.liveStartDate = val[0];
        this.ruleForm.onDetailDtos.liveEndDate = val[1];
      }
    },

    cancel() {
      this.$router.back();
    },

    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let params = { ...this.ruleForm };
              delete params["showDate"];
              // 处理数据detailDtos
              params.detailDtos = [];
              if (params.detailTypes.indexOf(1) !== -1) {
                delete params.onDetailDtos["liveDate"];
                params.detailDtos.push(params.onDetailDtos);
              }
              if (params.detailTypes.indexOf(2) !== -1) {
                delete params.offDetailDtos["liveDate"];
                params.detailDtos.push(params.offDetailDtos);
              }
              delete params["onDetailDtos"];
              delete params["offDetailDtos"];

              if (!this.editFlag) {
                // 新增操作
                addCourseTicket(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.$refs["ruleForm"].resetFields();
                  if (params.limitTicketId) {
                    this.$confirm(
                      `该预约关联了限制预约活动，请前往限制预约名单完成数据初始化。`,
                      "系统提示",
                      {
                        confirmButtonText: "马上设置",
                        cancelButtonText: "以后再说",
                        type: "warning",
                      }
                    )
                      .then(() => {
                        // 点击“马上设置”，跳转至限制预约名单页面
                        this.goTicketManage(res.data);
                      })
                      .catch(() => {
                        // 取消操作
                        this.goBack();
                      });
                  } else {
                    this.goBack();
                  }
                });
              } else {
                updateCourseTicket(params).then((res) => {
                  if (!res || res.code != 0) return;
                  setItem(this.REFRESH_FLAG, true);
                  this.$message.success(res.msg);
                  this.goBack();
                  this.$refs["ruleForm"].resetFields();
                });
              }
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.editFlag) {
            this.isCourseInit = true;
            this.ruleForm = JSON.parse(JSON.stringify(this.resetForm));
          } else {
            Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
          }
        })
        .catch(() => {});
    },
    // 关联直播列表
    getLiveRoomData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLiveRoomSelectPage({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.liveRoomData = [...this.liveRoomData, ...data.records];
            } else {
              this.liveRoomData = data.records;
            }
            let { current, total, size } = data;
            this.liveRoomMore = this.liveRoomData.length < total;
            this.liveRoomPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    liveRoomChange(e) {
      this.isLiveRoomInit = false;
    },
    // 线上学习-关联直播变更
    changeLiveRoom(val) {
      if (!!val) {
        let item = this.liveRoomData.filter((item) => item.uuid == val)[0];
        this.ruleForm.onDetailDtos.bizName = item.name;
        this.ruleForm.onDetailDtos.liveDate = [
          item.startDateStr,
          item.endDateStr,
        ];
        this.ruleForm.onDetailDtos.liveStartDate = item.startDateStr;
        this.ruleForm.onDetailDtos.liveEndDate = item.endDateStr;
      }
    },
    // 讲师列表
    getLecturerData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLecturerParamList({ page, lecturerName: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.lecturerData = [...this.lecturerData, ...data.records];
            } else {
              this.lecturerData = data.records;
            }
            let { current, total, size } = data;
            this.lecturerMore = this.lecturerData.length < total;
            this.lecturerPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    // 关联限制预约活动 列表
    getTicketLimitData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        selectPageLimit({ page, name: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.limitTicketData = [...this.limitTicketData, ...data.records];
            } else {
              this.limitTicketData = data.records;
            }
            let { current, total, size } = data;
            this.limitTicketMore = this.limitTicketData.length < total;
            this.limitTicketPage = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    // 关联课程列表
    getCourseData({ page = 1, more = false, keyword = "" } = {}) {
      if (!this.ruleForm.offDetailDtos.bizId) {
        return this.$message.error("请先选择关联班级！");
      } else {
        return new Promise((resolve) => {
          getCourseList({ page, classId: this.ruleForm.offDetailDtos.bizId })
            .then(({ code, data }) => {
              if (code !== 0) return;
              this.courseData = data;
              this.courseMore = false;
              resolve();
            })
            .catch((_) => {
              resolve();
            });
        });
      }
    },
    // 清空关联课程 列表数据
    initCourseData() {
      this.courseData = [];
      this.isCourseInit = true;
      this.coursePage = 1;
    },
    /** 关联限制预约活动 变更 */
    changeLimitTicket(val) {
      if (!!val) {
        let item = this.limitTicketData.filter((item) => item.uuid == val)[0];
        this.ruleForm.limitTicketName = item.name;
      }
    },
    limitTicketChange(e) {
      this.isLimitTicketInit = false;
    },
    /** 关联课程变更 */
    changeCourse(val) {
      if (!!val) {
        let item = this.courseData.filter((item) => item.uuid == val)[0];
        this.ruleForm.offDetailDtos.subBizName = item.courseName;
        // 联动线下学习时间
        this.ruleForm.offDetailDtos.liveDate = [
          item.teachingStartDate,
          item.teachingEndDate,
        ];
        this.ruleForm.offDetailDtos.liveStartDate = item.teachingStartDate;
        this.ruleForm.offDetailDtos.liveEndDate = item.teachingEndDate;
      } else {
        this.ruleForm.offDetailDtos.subBizName = "";
      }
    },
    courseChange(e) {
      this.isCourseInit = false;
    },
    lecturerChange(e) {
      this.isLecturerInit = false;
    },
    // 讲师变更
    changeLecturer(val) {
      console.log("-----changeValue---", val);
      let item = this.lecturerData.filter((item) => item.uuid == val)[0];
      this.ruleForm.lecturerName = item.lecturerNameDesc;
    },
    // 关联班级
    getClassList({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getStudyClassList({ page, className: keyword })
          .then(({ code, data }) => {
            if (code !== 0) return;
            if (more) {
              this.classList = [...this.classList, ...data.records];
            } else {
              this.classList = data.records;
            }
            let { current, total, size } = data;
            this.moreClass = this.classList.length < total;
            this.pageClass = current;
            resolve();
          })
          .catch((_) => {
            resolve();
          });
      });
    },
    // 改变关联班级
    changeClass(val) {
      this.ruleForm.offDetailDtos.bizId = val;
      if (!!val) {
        let item = this.classList.filter((item) => item.uuid == val)[0];
        this.ruleForm.offDetailDtos.bizName = item.className;
      } else {
        this.ruleForm.offDetailDtos.bizName = "";
      }
      // 清空关联课程
      this.initCourseData();
      this.ruleForm.offDetailDtos.subBizId = "";
      this.ruleForm.offDetailDtos.subBizName = "";
    },
    classChange(e) {
      this.isClassInit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.add-title {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-bottom: 6px;
  }
}
.download_text {
  color: #3a85ff;
  cursor: pointer;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}

.form-select {
  width: 100%;
}
.img_download_style {
  // margin-left: 20px;
  height: 160px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-size: 1rem;
  .download_text {
    color: #3a85ff;
    text-decoration: none;
  }
}
.tip_style {
  font-size: 1rem;
  float: left;
  height: 36px;
  line-height: 36px;
  background-color: #eee;
  padding: 0 6px;
  margin-top: 4px;
}
.sub_rect {
  .sub_title {
    font-size: 1rem;
    height: 48px;
    line-height: 48px;
    background-color: #eee;
    font-weight: bold;
    padding: 0 12px;
    margin-bottom: 24px;
  }
}
/deep/ .el-range-editor--small.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input {
  width: 100%;
}
</style>
